module.exports = __webpack_public_path__ + "img/direction_img.944b56aa.png";